// Stable per-device identifier для multi-device recording lock (§5.1).
//
// На web (incl. mobile web) — localStorage (persists across sessions, lost on
// browser data clear).
// На Capacitor — TODO(agent-recordings 100%): использовать SecureStorage через
// `@studyhub/platform/storage` port (peer compat с auth Bearer token storage).
//
// UUID v7 (time-ordered) генерируется один раз и persisted. Тот же deviceId
// используется для:
// - recording.create({ deviceId, forceTakeover })
// - Socket.IO room subscription (lock_transferred broadcast targets deviceId)
// - Crash recovery (use-recorder подбирает orphan chunks от того же deviceId).

import { uuidv7 } from "uuidv7";

const STORAGE_KEY = "sh.deviceId";

let cached: string | null = null;

export function getDeviceId(): string {
	if (cached) return cached;

	if (typeof window === "undefined") {
		// SSR safety — генерируем эфемерный (не сохраняем).
		return uuidv7();
	}

	try {
		const stored = window.localStorage.getItem(STORAGE_KEY);
		if (stored && stored.length > 0) {
			cached = stored;
			return stored;
		}
	} catch {
		// localStorage может быть недоступен (private mode, iframe sandbox).
		// Fallback на in-memory.
	}

	const generated = uuidv7();
	try {
		window.localStorage.setItem(STORAGE_KEY, generated);
	} catch {
		// no-op — следующий getDeviceId вернёт тот же из cached.
	}
	cached = generated;
	return generated;
}

/** Сброс — для тестов / debug / explicit user "clear identity" action. */
export function resetDeviceId(): void {
	cached = null;
	try {
		window.localStorage.removeItem(STORAGE_KEY);
	} catch {
		// no-op
	}
}
